<template>
    <div>
        <loadingCube v-if="!loaded" :loadingMessage="'GEOTEC'"></loadingCube>
        <div v-if="loaded" class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        {{ this.shortLocation }}
                    </div>
                    <div class="card-body">
                        <div class="col-4">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td class="align-middle">Active Workers</td>
                                        <td class="align-middle">{{ data.workersOnSite }}</td>
                                    </tr>
                                    <tr>
                                        <td class="align-middle">Workers assigned</td>
                                        <td class="align-middle">{{ data.workersAssigned }}</td>
                                    </tr>
                                    <tr>
                                        <td class="align-middle">Workers required</td>
                                        <td class="align-middle">{{ data.workersRequired }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row">
                            <div class="col-4 form-group">
                                <button class="w-100 orcaBtn greenBtn" @click="getExcelExport()">
                                    <span>DOWNLOAD REPORT</span>
                                </button>
                            </div>
                        </div>

                        <div class="expanded-contents">
                            <datatable :type="'worker_activity'" :row-data="data.workersActivity" :columns="columns"
                                :pagination-size="50"></datatable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <clock_in_out_worker_activity></clock_in_out_worker_activity>
    </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import datatable from "./clock_in_out_data_table"
import clock_in_out_worker_activity from "./clock_in_out_worker_activity"
export default {
    name: "clock_in_out_details",
    components: {
        loadingCube, 
        datatable, 
        clock_in_out_worker_activity
    },
    data() {
        return {
            orderJobId: 0,
            locationName: '',
            shortLocation: '',
            data: [],
            loaded: false,
            columns: [
                { headerName: 'Worker Name', field: 'workerName' },
                { headerName: 'Reference', field: 'workerReference' },
                { headerName: 'Job Title', field: 'jobTitle' },
                { headerName: 'Duration (hours)', field: 'duration' }
            ]
        }
    },
    beforeMount() {
        this.orderJobId = this.$route.params.orderJobId ?? this.$store.state.geotec.orderJobId;
        this.locationName = this.$route.params.fullLocationName;
        this.shortLocation = this.$route.params.shortLocationName ?? this.$store.state.geotec.locationName;
        
        axios.get(this.crmApiPath + 'geo_tracking/get_location_details/' + this.orderJobId).then(workers => {
            this.data = workers.data;
            this.loaded = true;
            this.$store.commit('SET_ORDER_JOB', this.orderJobId);
            this.$store.commit('SET_LOCATION_NAME', this.shortLocation);
        });
    },
    methods: {
        async getExcelExport() {
            axios.get(this.crmApiPath + 'geo_tracking/export_clock_history/' + this.orderJobId, { responseType: 'blob' })
                .then(response => {
                    const fileData = response.data;

                    // Create a Blob from the file data
                    const blob = new Blob([fileData], { type: 'application/octet-stream' });

                    // setting the file name to be downloaded
                    const ts = Date.now();
                    const filename = 'GeoTecClockHistory_' + ts + '.xlsx';

                    // function for downloading the file
                    // passing glob and required name
                    this.downloadFile(blob, filename);
                })
                .catch(error => {
                    console.error('Error-- ', error);
                });
        },

        downloadFile(blob, filename) {
            // url for the download
            const url = window.URL.createObjectURL(blob);

            // making an element for this link
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;

            // click the link to download the file for the user
            document.body.appendChild(link);
            link.click();

            // remove the temp elements
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }
    }
};
</script>